export const headersExportAbsenteeismConsult = [
    { v: "Identificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Nombre completo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Cargo", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Base", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Tipo de Requisito", t: "s", s: { font: { sz: 12, bold: true } } }, 
    { v: "Tipo de Ausencia", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Descripción de Ausencia", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Área del Empleado", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Inicio", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Fin", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Días", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Justificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Respuesta", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Verificación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Estado", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Creación", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Fecha Respuesta", t: "s", s: { font: { sz: 12, bold: true } } },
    { v: "Empleado Respuesta", t: "s", s: { font: { sz: 12, bold: true } } }
];